export enum CustomerActionEnum {
  DELETE = 'delete',
  REJECT = 'reject',
  REVOKE = 'revoke'
}
